export default "__VITE_ASSET__CbHwvVWH__"